// extracted by mini-css-extract-plugin
export default {"divpdf":"PDF_divpdf__CfR16","divdocument":"PDF_divdocument__wjuUn","botonnaranja":"PDF_botonnaranja__i-97o","section":"PDF_section__PNta2"};